<template>
    <div>
        <div class="page-top mb-1 mb-3 align-center clearfix">
            <h1 class="float-left"> Collection Companies </h1>
                <router-link to="/addCollectionCompany" class="btn btn-primary float-right active"> Add New Collection Company</router-link>
            <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" name="" />
            </div>
        </div>
        <table id="companyTable" class="table">
            <thead>
                <tr>
                    <th style="display: none;"></th>
                    <th>Name</th>
                    <th>Payment Engine</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Collection</th>
                    <th>Creation Charges Status</th>
                    <th>Creation Charges Type</th>
                    <th>Creation Charges</th>
                    <th>Consumption Charges Status</th>
                    <th>Consumption Charges Type</th>
                    <th>Consumption Charges</th>
                    <th>Edit</th>
                </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null
            };
        },
        mounted() {
            this.$Progress.start();
            var companyTable = $('#companyTable').DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                processing: true,
                serverSide: true,
                ajax: {
                    "url": "api/listFeeCompanies",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'name'},
                    {data: 'payment_engine'},
                    {data: 'phone'},
                    {data: 'email'},
                    {data: 'collection'},
                    {data: 'creation_fee_status'},
                    {data: 'creation_fee_type'},
                    {data: 'creation_fee'},
                    {data: 'consumption_fee_status'},
                    {data: 'consumption_fee_type'},
                    {data: 'consumption_fee'},

                    {data: 'company_id', sorting: false, render: function(data,type,full){
                        var $url = '/editCollectionCompany/'+full['company_id'];
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                    }}
                    
                ],
                "order": [[ 0, "desc" ]],
                "columnDefs": [{
                    className: "text-center",
                    "targets": [ 4 ]
                }],
                "initComplete": () => {
                    this.$Progress.finish();
                }
            });
             $('#customSearch').on( 'keyup', function () {
                companyTable.search(this.value).draw();
            });
        },
        created() {
            //
        }
    }
</script>
